function isNil(i){return null==i}module.exports=isNil;